import { render } from "./SatellitesIcon.vue?vue&type=template&id=fc4d90c8"
import script from "./SatellitesIcon.vue?vue&type=script&lang=js"
export * from "./SatellitesIcon.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__